import { useSelector } from "react-redux";
import { WardDetailsIcon } from "themes/Icon";
import style from "../ward_details.module.scss";

function LeftSection() {
  const { selectedUser } = useSelector((state) => state.wards);

  const wardData = [
    {
      label: "Region",
      value: selectedUser?.region_name,
    },
    {
      label: "Ward sectors",
      value: selectedUser?.ward_sector,
    },
    // {
    //   label: "Ward administrator",
    //   value: `${selectedUser?.first_name} ${selectedUser?.last_name}`,
    // },
    // {
    //   label: "Administrator contact number",
    //   value: selectedUser?.phone_number,
    // },
    // {
    //   label: "Registered CoJ users",
    //   value: "127",
    // },
  ];
  return (
    <div className={style["left-container"]}>
      <div className="flex align-center gap-2">
        <span className="">
          <WardDetailsIcon />
        </span>
        <h6 className={style["section-title"]}>
          Ward {selectedUser?.ward_code}
        </h6>
      </div>
      <div className="flex flex-column gap-5">
        {wardData.map((item) => {
          return item.value ? (
            <div key={item.label} className="flex flex-column gap-1">
              <h6 className={style["key-label"]}>{item.label}</h6>
              <p className={style["key-value"]}>{item.value}</p>
            </div>
          ) : null; // Returns null if item.value is falsy
        })}
      </div>
    </div>
  );
}

export default LeftSection;
